import {
  GUIDELINE_LIST_SEARCH, GUIDELINE_LIST_SEARCH_FAILURE, GUIDELINE_LIST_SEARCH_SUCCESS, GUIDELINE_DELETE, GUIDELINE_DELETE_FAILURE, GUIDELINE_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    guidelines: [],
    guidelineListNextPage: null,
    guidelineListCurrentPage: null
  },
  getters: {
    guidelineList: state => {
      return state.guidelines
    },
    guidelineListNextPage: state => {
      return state.guidelineListNextPage
    },
    guidelineListCurrentPage: state => {
      return state.guidelineListCurrentPage
    }
  },
  actions: {
    [GUIDELINE_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/guidelines'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GUIDELINE_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(GUIDELINE_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GUIDELINE_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('GUIDELINE_DELETE:' + params.id)
      var data = params.data
      var url = '/master/guidelines/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GUIDELINE_DELETE_FAILURE, res.data)
          } else {
            commit(GUIDELINE_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [GUIDELINE_LIST_SEARCH_FAILURE] (state, params) {
      console.log('GUIDELINE_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GUIDELINE_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('GUIDELINE_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.guidelines = state.domains.concat(data.data)
        state.guidelineListCurrentPage = data.meta['current-page']
      } else {
        state.guidelines = data.data
        state.guidelineListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.guidelineListNextPage = data.links['next']
      } else {
        state.guidelineListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [GUIDELINE_DELETE_FAILURE] (state, data) {
      console.log('GUIDELINE_DELETE_FAILURE')
    },
    [GUIDELINE_DELETE_SUCCESS] (state, data) {
      console.log('GUIDELINE_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/guideline-list.js